export default "/directory/static/additional_shooter_available.6469bcdd.svg";